import { Button, Container, Heading, Section } from 'react-bulma-components';
import React, { Fragment } from 'react';

import { Login } from '../containers'
import NetworkError from '../components/networkerror';
import ServerError from '../components/servererror';
import _ from 'lodash';
import { navigate } from '@reach/router';

const DefaultError = ({ error, children }) => {

    if(_.get(error, "graphQLErrors[0].extensions.code")==='UNAUTHENTICATED'){
      return <p>UNAUTHENTICATED</p>;
    }
    if (_.get(error, "graphQLErrors[0].extensions.code")==="FORBIDDEN") 
    {
      return(
        <Section>
        <Container>
          <Heading size={5} renderAs="p">{error.message}</Heading>
          <Heading subtitle renderAs="p">Please, see our subscription plans.</Heading>
          <Button color="primary" onClick={() => navigate('/pricing')}>See pricing</Button>
        </Container>
        </Section>
      ) 
/*       return error.graphQLErrors.map(error => {
          if(error.extensions.code==="FORBIDDEN"){
            return <p>Hey, {error.message}</p>
          }
        } */
    }
/*      return(
        <>
        graphQLErrors: 
        {error.graphQLErrors.map(error => 
          <p>{error.message}</p>
        )}
        <ServerError />
        <code><pre>{JSON.stringify(error, undefined, 2)}</pre></code>
        </>
    ); */
  
  

  if (error.networkError)
  {
    if(!error.networkError.result) {
      return <NetworkError />;
    }
    else {
      return (
      <><ServerError />
      <code><pre>{JSON.stringify(error, undefined, 2)}</pre></code>
      </>)
    }
  } 

    return (
      <Fragment>
        Default error:
        <code><pre>{JSON.stringify(error, undefined, 2)}</pre></code>
      </Fragment>
    )
  

};

export default DefaultError;